export const GLOBAL66_HELP_URL = 'https://ayuda.global66.com/s/';

/** Última forma (`home`/`onboarding`) del skeleton de la home, para arrancar la recarga con ella. */
export const LAYOUT_SKELETON_VARIANT_STORAGE_KEY = 'g66:b2b:layout-skeleton-variant';

export const PERSISTED_LAYOUT_SKELETON_VARIANTS = ['home', 'onboarding'] as const;

/** Tope de `redirect` encadenados al resolver la ruta inicial: corta un ciclo mal configurado. */
export const MAX_INITIAL_ROUTE_REDIRECTS = 5;

export const GLOBAL66_MAIN_LAYOUT_URLS = {
  help: GLOBAL66_HELP_URL,
} as const;
